import request from "@/utils/request";

// 查询学段
export const  listPeriod =(query) =>{
    return request({
        url: "/authservice/report/listPeriod",
        method:"get",
        params: query
    })
}

// 查询学科
export const  listSubject =(query) =>{
    return request({
        url: "/authservice/report/listSubject",
        method:"get",
        params: query
    })
}

// 查询量表
export const  listScale =(data) =>{
    return request({
        url: "/authservice/report/listScale",
        method:"post",
        data: data
    })
}

// 创建课程视频分析
export const  createCourseTask =(data) =>{
    return request({
        url: "/authservice/report/create",
        method:"post",
        data: data
    })
}

// 分页查询课程视频分析
export const  pageCourseTask =(data) =>{
    return request({
        url: "/authservice/report/page",
        method:"post",
        data: data
    })
}

// 删除课程视频分析
export const  delCourseTask =(query) =>{
    return request({
        url: "/authservice/report/delete",
        method:"get",
        params: query
    })
}

// 查询课程视频分析详情
export const  infoCourseTask =(query) =>{
    return request({
        url: "/authservice/report/info",
        method:"get",
        params: query
    })
}

// 查询课程视频分析详情
export const  infoCourseReport =(query) =>{
    return request({
        url: "/authservice/report/reportInfo",
        method:"get",
        params: query
    })
}

// 查询维度数据-点击查看数据解析
export const  queryDataAnalysis =(data) =>{
    return request({
        url: "/authservice/report/queryDataAnalysis",
        method:"post",
        data: data
    })
}

// 查询课程视频分析详情
export const  queryAppendixAData =(query) =>{
    return request({
        url: "/authservice/report/queryAppendixAData",
        method:"get",
        params: query
    })
}

// 附录B-查看课堂教学事件分析
export const  teachingEventData =(query) =>{
    return request({
        url: "/authservice/report/teachingEventData",
        method:"get",
        params: query
    })
}

// 附录B-课堂活动分析
export const  classActivityData =(query) =>{
    return request({
        url: "/authservice/report/classActivityData",
        method:"get",
        params: query
    })
}
// 附录B-课堂活动分析
export const  teachingBehaviorData =(query) =>{
    return request({
        url: "/authservice/report/teachingBehaviorData",
        method:"get",
        params: query
    })
}

// 附录B-师生对话深度评估
export const  interactiveEvaData =(query) =>{
    return request({
        url: "/authservice/report/interactiveEvaData",
        method:"get",
        params: query
    })
}

// 附录B-师生对话深度评估
export const  stData =(query) =>{
    return request({
        url: "/authservice/report/stData",
        method:"get",
        params: query
    })
}

// 附录B-RT-CH图数据
export const  rtChData =(query) =>{
    return request({
        url: "/authservice/report/rtChData",
        method:"get",
        params: query
    })
}

// 附录B-弗兰德斯教学模型互动矩阵图数据
export const  fldsInteractionData =(query) =>{
    return request({
        url: "/authservice/report/fldsInteractionData",
        method:"get",
        params: query
    })
}


// 查询用户报告列表
export const  listUserReport =(query) =>{
    return request({
        url: "/authservice/report/listUserReport",
        method:"get",
        params: query
    })
}
